<template>
  <SignaturePad v-if="isSignaturePlaced" :has-default-autograph="false" />
</template>

<script setup lang="ts">
import SignaturePad from '@/components/signature/SignaturePad.vue';

defineProps({
  isSignaturePlaced: {
    type: Boolean,
    required: true
  }
});
</script>
